export const RATE_LIMIT_ERROR = 'Error Code VFE-429'
